// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"eT0os1eNL2u_","title":"_2ePZSl5Et3Zt","sub":"_1v09qB8-QJM3","social":"_2FNxBuktwPqR","email":"_2VruMfLDEQrP","button":"_1AeEpND2triW"};